import styled from "styled-components";

export const Title = styled.h1`
text-align: center;
font-weight: 500;
font-size: 1.5vw;
width: 70%;

span {
    font-weight: 800;
    color: #1476C6;
}

`;

export const Button = styled.button`
margin-top: 3%;
width: 300px;
height: 60px;
background-color: #A2D3FB;
color: #1476C6;
border-radius: 10px;
`;